import { List } from 'antd';
import styled from '@emotion/styled';
export const StyledList = styled(List)``;
